import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Badge } from './ui/Badge';
import { SocialProofBanner } from './SocialProofBanner';
import { SparklesIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
import { trackInitiateCheckout, trackLead } from './MetaPixel';
export function Hero() {
  const handleGetStarted = () => {
    trackInitiateCheckout();
    window.open('https://buy.stripe.com/7sY7sM4gh69WcVo3vJdnW07', '_blank');
  };
  const handleBookCall = () => {
    trackLead();
    window.open('https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ', '_blank');
  };
  return <section className="relative bg-gradient-to-br from-[var(--jet-black)] to-[var(--graphite-gray)] text-white py-20 px-6 overflow-hidden" data-id="element-126">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-128">
          <Badge variant="success" data-id="element-129">
            <SparklesIcon className="inline w-4 h-4 mr-1" data-id="element-130" />
            For Landscaping, Tree Service & Home Service Contractors
          </Badge>

          <motion.h1 className="text-5xl md:text-6xl font-bold mt-6 mb-6 leading-tight" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-131">
            Never Miss Another Lead.
            <br data-id="element-132" />
            <span className="text-[var(--viridia-green)]" data-id="element-133">Book More Jobs.</span>
          </motion.h1>

          <motion.p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-134">
            We reply to your messages in seconds and guide them straight to
            booking on your calendar—automatically. You just show up and do the
            work.
          </motion.p>

          <motion.p className="text-lg text-gray-400 mb-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-135">
            Choose ONE platform: Yelp, Facebook, or Instagram
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} data-id="element-136">
            <Button size="lg" onClick={handleGetStarted} data-id="element-137">
              Get Started - $297/month
            </Button>
            <Button size="lg" variant="outline" onClick={handleBookCall} data-id="element-138">
              Or Talk to Us First
            </Button>
          </motion.div>

          <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} data-id="element-139">
            <div className="flex items-center gap-2" data-id="element-140">
              <ClockIcon className="w-4 h-4" data-id="element-141" />
              <span data-id="element-142">Live in 2-3 days</span>
            </div>
            <span className="hidden sm:inline text-gray-500" data-id="element-143">•</span>
            <div className="flex items-center gap-2" data-id="element-144">
              <ShieldCheckIcon className="w-4 h-4 text-[var(--viridia-green)]" data-id="element-145" />
              <span data-id="element-146">
                <strong data-id="element-147">No setup fee</strong> • Cancel anytime
              </span>
            </div>
          </motion.div>

          <SocialProofBanner data-id="element-148" />
        </motion.div>
      </div>

      {/* Decorative gradient orbs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[var(--viridia-green)] opacity-10 rounded-full blur-3xl" data-id="element-149"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[var(--deep-teal)] opacity-10 rounded-full blur-3xl" data-id="element-150"></div>
    </section>;
}